import ComparisionFileTableComponent from 'features/wells/corrosion/components/ComparisonFileTableComponent';
import { Grid, Typography } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import ComparisionFileDetailComponent from 'features/wells/corrosion/components/ComparisionFileDetailComponent';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { selectCompareFilesData } from 'features/wells/corrosion/helpers/corrosionlogs.selectors';

const CompareLogsTableContainer = ({ classes, compareFilesData }) => {
  return (
    <>
      <Grid container>
        {compareFilesData.length === 0 && (
          <Grid item xs={12} className={classes.noData}>
            <Typography>No filters selected yet.</Typography>
          </Grid>
        )}
        {compareFilesData.length > 0 &&
          compareFilesData
            .sort(
              (date, logDate) =>
                new Date(date.logDate) - new Date(logDate.logDate),
            )
            .map((file) => {
              return (
                <Grid item xs={6} className={classes.logsContainer}>
                  <ComparisionFileDetailComponent file={file} />
                  <ComparisionFileTableComponent
                    logs={file?.corrosionLogFileData}
                  />
                </Grid>
              );
            })}
      </Grid>
    </>
  );
};

const styles = (theme) => ({
  logsContainer: {
    padding: theme.spacing(3),
  },
  noData: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export default compose(
  connect(
    (state) => ({
      compareFilesData: selectCompareFilesData(state),
    }),
    {},
  ),
  withStyles(styles),
)(CompareLogsTableContainer);
